import QuickEventsNavigationImpl from './quick-events-navigation.jsx';
import MojitoCore from 'mojito/core';
import PropTypes from 'prop-types';
import { noop } from 'mojito/utils';
const UIView = MojitoCore.Presentation.UIView;

/**
 * Quick events navigation view.
 *
 * @class QuickEventsNavigation
 * @memberof Mojito.Modules
 */

/**
 * QuickLeaguesNavigation prop types.
 *
 * @property {string} sportId - The id of a sport.
 * @property {string} [typeId] - The id of a sport class type, e.g., league, tournament. If provided, events for the specific type will be fetched. Otherwise, the component will fetch all live match and outright events for the specific sport.
 * @property {boolean} [isInPlay] - Determines which groupEvents will be shown and the intent that will be published for in-play or pre-match events.
 * @property {string} [selectedItemId] - The id of the event to be highlighted as selected in the list.
 * @property {Function} [onItemClick = () => {}] - Callback triggered when an event item is clicked.
 */
const propTypes = {
    sportId: PropTypes.string.isRequired,
    typeId: PropTypes.string,
    isInPlay: PropTypes.bool,
    selectedItemId: PropTypes.string,
    onItemClick: PropTypes.func,
};

const defaultProps = {
    onItemClick: noop,
};

export default UIView('QuickEventsNavigation', QuickEventsNavigationImpl, propTypes, defaultProps);
